// @flow

import React, { Component } from 'react';
import './PlayerCardHeader.css';
import { Confirmed, Projected } from 'component-library';
import InjuryStatus from '../../../UI/InjuryStatus';
import colors from '../../../../assets/values/colors';
import NumberFormat from 'react-number-format';
import Moment from 'moment';

// header

type Props = {
    sport: string,
    playerDetails: { [key: string]: any },
    player: { [key: string]: any },
    onClose: Function
};

type State = {
    hover: boolean
};

class PlayerCardHeader extends Component<Props, State> {
    state = {
        hover: false
    };
    hoverOn = () => {
        this.setState({ hover: true });
    };
    hoverOff = () => {
        this.setState({ hover: false });
    };

    addDefaultSrc(ev: { [key: string]: any }) {
        ev.target.src = 'https://dpyukwfjby8ty.cloudfront.net/headshots/nhl/low-res/0_90x90.png';
    }

    render() {
        let statusColor = colors.black;
        let playerStatus = '';
        let playerDisplay = '';
        let opponentDisplay = '';
        let projectionsDisplay = '';

        if (
            this.props.playerDetails.results.length > 0 &&
            this.props.playerDetails.isLoading === false &&
            this.props.playerDetails.results[0] !== undefined
        ) {
            const playerDetailResult = this.props.playerDetails.results[0];
            switch (playerDetailResult.injury_status) {
                case 'Active':
                    statusColor = colors.green;
                    break;
                case 'Out':
                case 'Out for Season':
                case 'Injured':
                case 'Doubtful':
                case 'Inactive':
                case 'Suspended':
                    statusColor = colors.red;
                    break;
                case 'Probable':
                case 'Questionable':
                default:
                    statusColor = colors.cautionBlue;
                    break;
            }
            if (playerDetailResult.injury_status !== '' && playerDetailResult.injury_status !== null) {
                playerStatus = <InjuryStatus color={statusColor} status={playerDetailResult.injury_status} />;
            }
            let playerTeamAndPosition = this.props.player.team + ' - ' + this.props.player.position + '  ';
            let playerOrderConfirmed = false;
            const playerOrderProjected = false;
            if (
                this.props.sport === 'mlb' &&
                playerDetailResult.next_event &&
                playerDetailResult.next_event['Lineup Order']
            ) {
                if (+playerDetailResult.next_event['Lineup Order'] !== 0) {
                    playerTeamAndPosition =
                        playerTeamAndPosition + ' | ' + playerDetailResult.next_event['Lineup Order'] + '';
                }
                if (playerDetailResult.next_event.Confirmed === 'Y') {
                    playerOrderConfirmed = true;
                }
            }
            if (this.props.sport === 'pga') {
                opponentDisplay = (
                    <div className={'inline-div inline-div-25'}>
                        <div className={'small-text right white-text'} />
                        <div className={'right media-small white-text'} />
                    </div>
                );
            } else if (playerDetailResult.next_event) {
                opponentDisplay = (
                    <div className={'inline-div inline-div-95'}>
                        <div className={'right media-small'}>
                            {Moment(playerDetailResult.next_event['Game Time']).format('M/D h:mm A')} ET&nbsp;
                            {playerDetailResult.next_event.Opp}
                        </div>
                    </div>
                );
            }
            if (playerDetailResult.default_position_id === '101') {
                projectionsDisplay = (
                    <div>
                        <div className={'inline-div inline-div-14 proj-label'}>
                            <div className={'media-small right white-text'}>Projections</div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Comp</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PassComProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Att</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PassAttProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>PYds</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PassYdsProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>PTDs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PassTDProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Int</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PassINTProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>RuYds</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RushYdsProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>RuTDs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RushTDProj}
                            </div>
                        </div>
                    </div>
                );
            } else if (playerDetailResult.default_position_id === '102') {
                projectionsDisplay = (
                    <div>
                        <div className={'inline-div inline-div-14 proj-label'}>
                            <div className={'media-small right white-text'}>Projections</div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Att</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RushAttProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>RuYds</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RushYdsProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>RuTDs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RushTDProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Tgts</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RecTargProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Rec</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RecCatchesProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>ReYds</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RecYdsProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>ReTDs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RecTDProj}
                            </div>
                        </div>
                    </div>
                );
            } else if (
                playerDetailResult.default_position_id === '103' ||
                playerDetailResult.default_position_id === '104') {
                projectionsDisplay = (
                    <div>
                        <div className={'inline-div inline-div-22 proj-label'}>
                            <div className={'media-small right white-text'}>Projections</div>
                        </div>
                        <div className={'inline-div inline-div-18'}>
                            <div className={'small-text right white-text'}>Tgts</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RecTargProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-18'}>
                            <div className={'small-text right white-text'}>Rec</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RecCatchesProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-18'}>
                            <div className={'small-text right white-text'}>ReYds</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RecYdsProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-18'}>
                            <div className={'small-text right white-text'}>ReTDs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RecTDProj}
                            </div>
                        </div>
                    </div>
                );
            } else if (playerDetailResult.default_position_id === '201') {
                projectionsDisplay = (
                    <div>
                        <div className={'inline-div inline-div-14 proj-label'}>
                            <div className={'media-small right white-text'}>Projections</div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Mins</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.MinutesProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Pts</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PointsProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Reb</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.ReboundsProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Ast</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.AssistsProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Blk</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.BlocksProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Stl</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.StealsProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>FTsM</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.FtmProj}
                            </div>
                        </div>
                    </div>
                );
            } else if (playerDetailResult.default_position_id === '301') {
                projectionsDisplay = (
                    <div>
                        <div className={'inline-div inline-div-14 proj-label'}>
                            <div className={'media-small right white-text'}>Projections</div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Singles</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.SinglesProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Doubles</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.DoublesProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Triples</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.TriplesProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>HRs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.HRProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>Runs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>RBIs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.RBIProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>SBs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.SBProj}
                            </div>
                        </div>
                    </div>
                );
            } else if (playerDetailResult.default_position_id === '302') {
                projectionsDisplay = (
                    <div>
                        <div className={'inline-div inline-div-12 proj-label'}>
                            <div className={'media-small right white-text'}>Projections</div>
                        </div>
                        <div className={'inline-div inline-div-12'}>
                            <div className={'small-text right white-text'}>IPs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PitchIPProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-10'}>
                            <div className={'small-text right white-text'}>W</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PitchWProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-10'}>
                            <div className={'small-text right white-text'}>L</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PitchLProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-10'}>
                            <div className={'small-text right white-text'}>QS</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PitchQSProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-10'}>
                            <div className={'small-text right white-text'}>ERs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PitchERProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-10'}>
                            <div className={'small-text right white-text'}>BBs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PitchBBProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-10'}>
                            <div className={'small-text right white-text'}>Ks</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PitchKProj}
                            </div>
                        </div>
                        <div className={'inline-div inline-div-10'}>
                            <div className={'small-text right white-text'}>Hs</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.PitchHProj}
                            </div>
                        </div>
                    </div>
                );
            } else if (playerDetailResult.default_position_id === '401' ||
                playerDetailResult.default_position_id === '403' ||
                playerDetailResult.default_position_id === '404' ||
                playerDetailResult.default_position_id === '405') {
                projectionsDisplay = (
                    <div>
                        <div className={'inline-div inline-div-14 proj-label'}>
                            <div className={'media-small right white-text'}>Projections</div>
                        </div>
                        <div className={'inline-div inline-div-20'}>
                            <div className={'small-text right white-text'}>Shots On Goal</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.ShotsProj}
                            </div>
                        </div>
                    </div>
                );
            } else if (playerDetailResult.default_position_id === '402') {
                projectionsDisplay = (
                    <div>
                        <div className={'inline-div inline-div-14 proj-label'}>
                            <div className={'media-small right white-text'}>Projections</div>
                        </div>
                        <div className={'inline-div inline-div-20'}>
                            <div className={'small-text right white-text'}>Saves</div>
                            <div className={'no-wrap media-small right white-text'}>
                                {playerDetailResult.projections.SavesProj}
                            </div>
                        </div>
                    </div>
                );
            }


            playerDisplay = (
                <div style={{ backgroundColor: playerDetailResult.team_color_main }}>
                    <a role={'button'} onClick={this.props.onClose}>
                        <i className={'close fas fa-times'} />
                    </a>
                    <div style={{ position: 'relative' }} className={'inline-div inline-div-35'}>
                        <div id={'player-headshot-image-container'}>
                            <img
                                src={playerDetailResult.headshot}
                                onError={this.addDefaultSrc}
                                style={{ width: '90px', height: '90px' }}
                                alt={playerDetailResult.full_name}
                            />
                        </div>
                        <div id={'player-headshot-name'} className={'header-text no-wrap white-text'}>
                            {playerDetailResult.full_name}
                            <div className={'header-text-small'}>
                                {playerTeamAndPosition}
                                {playerStatus}
                            </div>
                        </div>
                        <div
                            id={'player-headshot-gray-bar'}
                            style={{
                                backgroundColor:
                                    playerDetailResult.team_color_main === playerDetailResult.team_color_alt
                                        ? '#d3d3d3'
                                        : playerDetailResult.team_color_alt
                            }}
                        >
                            {opponentDisplay}
                            {playerOrderConfirmed ? <Confirmed paddingLeft="3" /> : ''}
                            {playerOrderProjected && playerOrderConfirmed === false ? (
                                <Projected paddingLeft="3" />
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <div className={'inline-div inline-div-60'}>
                        <div style={{ borderBottom: '1px solid #eaeaea' }}>
                            <div className={'inline-div inline-div-25 right'}>
                                <div className={'small-text white-text'}>DraftKings Salary</div>
                                <div className={'header-text white-text'}>
                                    <NumberFormat
                                        value={playerDetailResult.salaries.DraftKingsSalary}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </div>
                            </div>
                            <div className={'inline-div inline-div-25 right'}>
                                <div className={'small-text white-text'}>FanDuel Salary</div>
                                <div className={'header-text white-text'}>
                                    <NumberFormat
                                        value={playerDetailResult.salaries.FanDuelSalary}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </div>
                            </div>
                            {this.props.sport === 'nhl' ? '' :
                              <div className={'inline-div inline-div-25 right'}>
                                <div className={'small-text white-text'}>Yahoo Salary</div>
                                <div className={'header-text white-text'}>
                                    <NumberFormat
                                        value={playerDetailResult.salaries.YahooSalary}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </div>
                              </div>}
                            {playerDetailResult.default_position_id === '402' ? '' :
                              <div className={'inline-div inline-div-25 right'}>
                                <div className={'small-text white-text'}>FantasyDraft Salary</div>
                                <div className={'header-text white-text'}>
                                    <NumberFormat
                                        value={playerDetailResult.salaries.FantasyDraftSalary}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </div>
                              </div>}
                        </div>
                        {projectionsDisplay}
                    </div>
                    <div
                        style={{ verticalAlign: 'top', marginTop: '33px' }}
                        className={
                            this.state.hover
                                ? 'inline-div inline-div-5 arrow-right arrow-right-white hover'
                                : 'inline-div inline-div-5'
                        }
                    />
                </div>
            );
        }
        return playerDisplay;
    }
}

export default PlayerCardHeader;



// WEBPACK FOOTER //
// ./src/components/Main/PlayerCard/PlayerCardHeader/PlayerCardHeader.js